<template>
<!-- 
  Author: lan.h
  Date: 2021-10-18
  content: 上市企业榜 
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>TOP 50 INNOVATIVE PUBLIC COMPANIES</p>
        <h1>上市企业榜</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" @click="toA('#list-info')">
          <p class="links-index">01</p>
          <p class="links-name">上市企业榜介绍</p>
          <i class="el-icon-bottom"></i>
        </div>
        <div class="links-item js-lower-anchor" @click="toA('#list-table')">
          <p class="links-index">02</p>
          <p class="links-name">历届上市企业榜</p>
          <i class="el-icon-bottom"></i>
        </div>
      </div>
    </div>
    <div class="p_image">
      <div class="p_image_inner">
        <img src="~/img/main/ss.png">
      </div>
    </div>
    <div class="list-content" id="list-info">
      <!-- 榜单介绍 -->
      <div class="info">
        <div class="list-title">上市企业榜介绍</div>
        <div class="list-desc">{{introduce}}</div>
      </div>
    </div>
    <!-- 历届榜单 -->
    <div class="his-content" id="list-table">
      <div class="list-content">
        <div class="info">
          <div class="list-title">历届上市企业榜</div>
          <div class="list-png">
            <img src="~/img/main/list.png" />
          </div>
        </div>
        <div class="table-title">
          <div class="award-title">
            <img class="title-left" src="~/img/main/left.png" />
            <div class="list-name">
              <div class="year">{{time_index.year}}</div>
              <div class="name">{{time_index.name}}</div>
            </div>
            <img class="title-left" src="~/img/main/right.png" />
          </div>
        </div>
        <!-- 表格 -->
        <div class="list-wap">
          <div class="list-table" ref="table">
            <div class="business-card">
              <div class="card-content" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-for="result,index in tableData" :key="index" >
                <div>
                  <el-tooltip v-if="getResult2(result).description" class="item" effect="dark" :content="getResult2(result).description" placement="top">
                    <a v-if="getResult2(result).url" :href="getResult2(result).url" target="_blank">
                      <img :src="$store.state.img_req_url + getLogo(result)" alt="">
                    </a>
                    <img v-else :src="$store.state.img_req_url + getLogo(result)" alt="">
                  </el-tooltip>
                  <div v-else>
                    <a v-if="getResult2(result).url" :href="getResult2(result).url" target="_blank">
                      <img :src="$store.state.img_req_url + getLogo(result)" alt="">
                    </a>
                    <img v-else :src="$store.state.img_req_url + getLogo(result)" alt="">
                  </div>
                </div>
                <p class="card-title">{{result}}</p>
              </div>
            </div>
          </div>
          <!-- 锚点 -->
          <div class="anchor-wap">
            <ul class="anchor">
              <li class="anchor-item" v-for="item, index in anchor_list" :key="item.id" @click="openYear(item, index)">
                <div class="anchor-item-title">
                  <div>
                    <span>{{item.name}}</span>
                    <span class="baoming" v-if="item.type == '2'">报名中</span>
                  </div>
                  <!-- 报名中 -->
                  <!-- <i v-if="!item.is_open && item.type == '2'" class="el-icon-right"></i> -->
                  <!-- 加号 -->
                  <i v-if="!item.is_open" class="el-icon-plus"></i>
                  <!-- 减号 -->
                  <i v-if="item.is_open" class="el-icon-minus"></i>
                </div>
                <div class="radio" v-if="item.is_open">
                  <el-radio-group v-model="top_list_id" @change="changeType($event, item)">
                    <el-radio :label="val.id" v-for="val in item.topList" :key="val.id">{{val.title}}</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="anchor-bottom"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAwardsYearList, getVbTopListById } from '@/service/main.js'
import { list_mixin, scroll_mixin } from 'js/list_mixins'
export default{
  mixins: [list_mixin, scroll_mixin],
  data() {
    return {
      tableData: [],
      loading: false,
      anchor_list: [],
      top_list_id: '',
      time_index: {},
      detail: '',
      key_index: ''
    }
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta
    },
    awards_id() {
      let id = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).id
      return id
    },
    introduce() {
      let introduce = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).introduce
      return introduce
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll('anchor', 20)
      }
      window.onresize = () => {
        _this.listenerScroll('anchor', 20)
      }
    })
  },
  beforeDestroy(){
    window.onscroll = null
    window.onresize = null
  },
  created() {
    this.imgLoad()
    this.getAwardsYearList()
  },
  methods: {
    imgLoad() {
      !function(){
        var imgNeed = [require('../../assets/img/main/pc.png')],
            len = imgNeed.length,
            i = 0;
 
          function loadImg(i){
              var img = new Image();
              img.src = imgNeed[i];
              img.onload = function(){
                  if(i++<len-1){
                      loadImg(i)
                  }else{
                    $('.p_image').addClass('p_image_ani')
                  }
              }
          }
          loadImg(i);
      }()
    },
    // 锚点跳转
    toA(id) {
      $("html,body").animate({ scrollTop: $(id).offset().top - 80 }, 500);
    },
    //获取年数据
    async getAwardsYearList() {
      let res = await getAwardsYearList({
        awards_id: this.awards_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        let num = 0
        let arr = res.res.filter(item => item.topList.length > 0)
        arr.forEach(item =>{
          if(num < 1 && item.type == '1'){
            item.is_open = true
            num++
          }else{
            item.is_open = false
          }
        })
        this.$set(this.$data, 'anchor_list', arr)
        let temp = this.anchor_list.find(item => item.type == '1')
        let top_list_id = temp.topList[0].id
        this.top_list_id = top_list_id
        this.time_index = {
          name: temp.topList[0].title,
          year: temp.name
        }
        this.getVbTopListById(top_list_id)
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取表格数据
    async getVbTopListById(top_list_id) {
      this.loading = true
      let res = await getVbTopListById({
        top_list_id: top_list_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        let deal_temp = this.dealListEntity(res.res.content)
        this.key_index = top_list_id
        this.$set(this.$data, 'tableData', deal_temp.arr)
        this.$set(this.$data, 'detail', res.res)
        this.matching_results = res.res.matching_results ? JSON.parse(res.res.matching_results) : []
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //单选按钮
    changeType(val, item) {
      if(item.type == '2'){ //报名中
        let temp = item.topList.find(i => i.id == val)
        temp.url ? window.open(temp.url, '_blank') : ''
      }else{
        this.time_index.name = item.topList.find(item => item.id == val).title
        this.time_index.year = item.name
        $("html,body").animate({ scrollTop: $('#list-table').offset().top - 80 }, 500)
        this.getVbTopListById(val)
      }
      
    },
    //展开年
    openYear(item, index) {
      // if(!item.is_open && item.type == '2'){ //报名中
      //   item.url ? window.open(item.url, '_blank') : ''
      // }
      // else{
        this.anchor_list.forEach(item =>{
          item.is_open = false
        })
        let temp = this.anchor_list[index]
        temp.is_open = true
        this.$set(this.$data.anchor_list, index, temp)
      // }
    },
    //处理实体 跳转
    getResult2(e) {
      let temp = this.matching_results.find(i => i.short_name == e)
      let url = ''
      if(this.detail.jump == '1'){ //动脉橙
        if(temp && temp.uid){
          let route = temp.type == '0' ? 'companyDetail' : temp.type == '1' ? 'orgDetail' : 'hospitalDetail'
          url = 'https://vbdata.cn/' + route + '/' + temp.uid
        }else{
          url = ''
        }
      }else if(this.detail.jump == '2'){ //官网
        url = temp && temp.main_page ? temp.main_page : ''
      }else{
        url = ''
      }
      return {
        url: url,
        description: temp && temp.description ? temp.description : ''
      }
    },
    getLogo(e){
      let entity = this.matching_results.find(i => i.short_name == e)
      return entity ? entity.logo_path : ''
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/main/list.stylus';
.anchor-wap
  .anchor
    max-height 400px
.list-table
  min-height 400px
.his-content
  .table-title
    .award-title
      .title-left
        margin-right 10px
        margin-top 35px
        width 71px
        height 14px
      .title-right
        margin-left 10px
        margin-top 35px
        width 71px
        height 14px
      .list-name
        text-align center
        .name
          margin-top -20px
          color #D9BB9E
          font-weight bold
          font-size 26px
          line-height 1
        .year
          font-size 56px
          line-height 1
          font-family Arial
          font-weight 900
          color #D9BB9E
          opacity 0.1
          z-index -1
.business-card
  width 100%
  display flex
  flex-wrap wrap
  justify-content center
  .card-content
    margin-top 15px
    width calc((100% - 14*4px) / 5)
    text-align center
    padding 8px
    >div
      width 100%
      height 100%
      background-color #fff
      display flex
      justify-content center
      align-items center
      height 56px
      >div
        width 100%
        height 100%
      a 
        width 100%
        height 100%
        display flex
        justify-content center
        align-items center
      img
        max-width 100%
        max-height 100%
      &:hover
        opacity 0.5
        box-shadow 0px 0px  9px 0px #aaa
        cursor pointer
    p
      margin-top 10px
      font-size 14px
      font-weight 500
      color #fff
      line-height 22px
</style>